import { render, staticRenderFns } from "./multiplechoice.vue?vue&type=template&id=fa2d5db6&scoped=true&"
import script from "./multiplechoice.vue?vue&type=script&lang=js&"
export * from "./multiplechoice.vue?vue&type=script&lang=js&"
import style0 from "./multiplechoice.vue?vue&type=style&index=0&id=fa2d5db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2d5db6",
  null
  
)

export default component.exports